import { IFilter } from '../../types/advancedFilters';
import { OfferTypeContainer } from '../../containers/advancedFilters/OfferTypeContainer';

export const offerType: IFilter = {
  component: OfferTypeContainer,
};
